import PersonalDataIcon from './component'

export default PersonalDataIcon